export const buttonKinds = [
  '',
  'primary',
  'secondary',
  'tertiary',
  'ghost',
  'danger',
  'danger--ghost',
  'danger--tertiary',
];
export const buttonSizes = ['', 'default', 'field', 'small', 'sm', 'lg', 'xl'];

const CvButtonConsts = { buttonKinds, buttonSizes };
export default CvButtonConsts;
